/* geoip2 */
"use strict";var geoip2=function(){function Lookup(e,t,o,n){this.successCallback=e,this.errorCallback=t,this.geolocation=o&&o.hasOwnProperty("geolocation")?o.geolocation:navigator.geolocation,this.type=n}var exports={};Lookup.prototype.returnSuccess=function(e){this.successCallback&&"function"==typeof this.successCallback&&this.successCallback(this.fillInObject(this.objectFromJSON(e)))},Lookup.prototype.returnError=function(e){this.errorCallback&&"function"==typeof this.errorCallback&&(e||(e={error:"Unknown error"}),this.errorCallback(e))},Lookup.prototype.objectFromJSON=function(json){return"undefined"!=typeof window.JSON&&"function"==typeof window.JSON.parse?window.JSON.parse(json):eval("("+json+")")};var fillIns={country:[["continent","Object","names","Object"],["country","Object","names","Object"],["registered_country","Object","names","Object"],["represented_country","Object","names","Object"],["traits","Object"]],city:[["city","Object","names","Object"],["continent","Object","names","Object"],["country","Object","names","Object"],["location","Object"],["postal","Object"],["registered_country","Object","names","Object"],["represented_country","Object","names","Object"],["subdivisions","Array",0,"Object","names","Object"],["traits","Object"]]};return Lookup.prototype.fillInObject=function(e){for(var t="country"===this.type?fillIns.country:fillIns.city,o=0;o<t.length;o++)for(var n=t[o],r=e,s=0;s<n.length;s+=2){var i=n[s];r[i]||(r[i]="Object"===n[s+1]?{}:[]),r=r[i]}try{Object.defineProperty(e.continent,"continent_code",{enumerable:!1,get:function(){return this.code},set:function(e){this.code=e}})}catch(c){e.continent.code&&(e.continent.continent_code=e.continent.code)}if("country"!==this.type)try{Object.defineProperty(e,"most_specific_subdivision",{enumerable:!1,get:function(){return this.subdivisions[this.subdivisions.length-1]},set:function(e){this.subdivisions[this.subdivisions.length-1]=e}})}catch(c){e.most_specific_subdivision=e.subdivisions[e.subdivisions.length-1]}return e},Lookup.prototype.getGeoIPResult=function(){var e,t,o=this,n="//geoip-js.maxmind.com/geoip/v2.1/"+this.type+"/me?",r={referrer:location.protocol+"//"+location.hostname};if(!this.alreadyRan){this.alreadyRan=1,"Microsoft Internet Explorer"===navigator.appName&&window.XDomainRequest&&navigator.appVersion.indexOf("MSIE 1")===-1?(t=new XDomainRequest,n=window.location.protocol+n,t.onprogress=function(){}):(t=new window.XMLHttpRequest,n="https:"+n);for(e in r)r.hasOwnProperty(e)&&r[e]&&(n+=e+"="+encodeURIComponent(r[e])+"&");n=n.substring(0,n.length-1),t.open("GET",n,!0),t.onload=function(){if("undefined"==typeof t.status||200===t.status)o.returnSuccess(t.responseText);else{var e,n=t.hasOwnProperty("contentType")?t.contentType:t.getResponseHeader("Content-Type");if(/json/.test(n)&&t.responseText.length)try{e=o.objectFromJSON(t.responseText)}catch(r){e={code:"HTTP_ERROR",error:"The server returned a "+t.status+" status with an invalid JSON body."}}else e=t.responseText.length?{code:"HTTP_ERROR",error:"The server returned a "+t.status+" status with the following body: "+t.responseText}:{code:"HTTP_ERROR",error:"The server returned a "+t.status+" status but either the server did not return a body or this browser is a version of Internet Explorer that hides error bodies."};o.returnError(e)}},t.ontimeout=function(){o.returnError({code:"HTTP_TIMEOUT",error:"The request to the GeoIP2 web service timed out."})},t.onerror=function(){o.returnError({code:"HTTP_ERROR",error:"There was a network error receiving the response from the GeoIP2 web service."})},t.send(null)}},exports.country=function(e,t,o){var n=new Lookup(e,t,o,"country");n.getGeoIPResult()},exports.city=function(e,t,o){var n=new Lookup(e,t,o,"city");n.getGeoIPResult()},exports.insights=function(e,t,o){var n=new Lookup(e,t,o,"insights");n.getGeoIPResult()},exports}();
//# sourceMappingURL=geoip2.js.map
/* end geoip2 */

theme_.dayMap = {
    "en": {
        "Sunday": "Sun",
        "Monday": "Mon",
        "Tuesday": "Tues",
        "Wednesday": "Wed",
        "Thursday": "Thurs",
        "Friday": "Fri",
        "Saturday": "Sat"
    },
    "fr": {
        "Sunday": "Dim",
        "Monday": "Lun",
        "Tuesday": "Mar",
        "Wednesday": "Mer",
        "Thursday": "Jeu",
        "Friday": "Ven",
        "Saturday": "Sam"
    }
}

theme_.close = {
    "en": "Closed",
    "fr": "Fermé"
}
theme_.open = {
    "en": "Open today until ",
    "fr": "Ouvert aujourd'hui jusqu'à "
}

theme_.utils = {
    toObject: function(object_string) {
        var parameters = {};
        var elements;

        if (!object_string) {
            return {};
        }

        // Decode the query string to get original characters
        object_string = decodeURIComponent(object_string);

        // Split into each element
        elements = object_string.split('&');

        for (var i = 0; i < elements.length; i++) {
            var element = elements[i].split('=');
            parameters[element[0]] = element[1] || null;
        };

        return parameters;
    },

    getURLParams: function(url) {
        var url = url || window.location.href;
        // Get the string after the '?' from the URL
        var query_string = url.split(/\?([^\#]+)/)[1];

        if (!query_string) {
            return {};
        }

        return this.toObject(query_string);
    }
}

$(function () {
    /**
     * The store locator object takes care of filtering,
     * rendering the map, handling filters, geo location,
     * geo coding, rendering store results, and pagination
     */
    var Store_locator = new function () {
        function Store_locator() {
            var store_locator = this;
            this.key = "AIzaSyD9zUfv8hp6EUC9YezuOa6yd0OXMZ8b-ts";
            this.$container = $(".js-store-locator");
            this.$resultsCountContainer = $(".js-results-count-container");
            this.$resultsCount = $(".js-results-count", this.$resultsCountContainer);
            this.$storeListContainer = $(".js-store-list", this.$container);
            this.$radiusCopy = $(".js-radius-dropdown-copy", this.$container);
            this.$filterRadius = $(".js-filter-radius", this.$container);
            this.$geolocateButton = $(".js-geolocate", this.$container);
            this.$addressLookup = $(".js-search-input", this.$container);
            this.$addressSubmit = $(".js-search-submit", this.$container);
            this.$mapToggleButton = $(".js-map-toggle", this.$container);
            this.$mapContainer = $("#map_container", this.$container);

            this.$myLocation = $('.my-location button', this.$container);
            this.$submit = $('.store__filters-search-button', this.$container);

            this.dropdowns = new Dropdowns(this.$container);
            this.pagination = new Pagination($('.js-pagination-container', this.$container), this);

            this.filtersManager = new FilterManager($('.js-filters-container', this.$container), $('.js-selected-filters', this.$container), this);

            this.previousWidth = window.outerWidth;
            this.fitBoundsPadding = 40;
            this.countPerPage = 6;
            this.markers = [];
            this.labels = [];
            this.storepicker = this.$container.hasClass("js-store__picker");


            this.$geolocateButton.on('click', function () {
                store_locator.geolocate();
            });

            this.$addressSubmit.submit(function () {
                store_locator.geocode();
                return false;
            });

            this.$mapToggleButton.on('click', function () {
                store_locator.$mapToggleButton.toggleClass('active');
                store_locator.toggleMap();
            });

            this.$filterRadius.on('change', function () {
                store_locator.$radiusCopy.html($(this).data('value'));
                store_locator.loadStores();
            });

            this.$myLocation.on('click', function () {
                
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                        
                        const { latitude, longitude } = position.coords;
                            const _url = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=jsonv2`;
                            fetch(_url).then(res => res.json()).then(data => {
                                if(data?.address?.postcode){
                                    store_locator.$addressLookup.val(data.address.postcode);
                                    store_locator.$submit.trigger('click');
                                }
                            });
                        }
                    );
                 }
    

            });

            $(window).resize(function () {
                if (window.outerWidth >= 1024 && store_locator.previousWidth < 1024 && !store_locator.storepicker) {
                    store_locator.$mapToggleButton.addClass('active');
                    store_locator.toggleMap();
                } else if (window.outerWidth < 1024 && store_locator.previousWidth >= 1024 || store_locator.storepicker) {
                    store_locator.$mapToggleButton.removeClass('active');
                    store_locator.toggleMap();
                } else if (store_locator.storeBounds) {
                    window.theme.map.fitBounds(store_locator.storeBounds, store_locator.fitBoundsPadding);
                }

                store_locator.previousWidth = window.outerWidth;
            });

            if (store_locator.storepicker) {
                var checkoutDestination = store_locator.$container.data('checkout-destination');

                store_locator.$storeListContainer.on('click', '.js-pick-store', function () {
                    var id = this.getAttribute('data-store-id');
                    var this_store = store_locator.stores[id];
                    checkoutDestination += this_store.checkout_auto_fill;
                    var store_brand = this_store.brand;
                    var open_hours = this_store.open_hours;
                    var store_address = this_store.address;
                    var store_tel = this_store.phone;
                    var store_full_name = store_address.name + " " + this_store.brand + " #" + this_store.store_code;
                    var store_code = this_store.store_code;

                    $.post('/cart/update.js', {
                        attributes: {
                            checkout_type: "store",
                            open_hours: JSON.stringify(open_hours),
                            store_address: JSON.stringify(store_address),
                            store_tel: store_tel,
                            store_brand: store_brand,
                            store_name: store_address.name,
                            store_code: store_code,
                            store_full_name: store_full_name,
                            store_formatted_hours: store_locator.processHours(open_hours).join('')
                        }
                    }, function () {
                        window.location.href = checkoutDestination;
                    }, "json");
                });
            }
            if (window.outerWidth >= 1024 && !store_locator.storepicker) {
                store_locator.$mapToggleButton.addClass('active');
            }

            // Geolocate and load stores
            this.geolocate();
        }

        /**
         * The Dropdowns object keeps track of all the dropdowns and ensuring that
         * atmost only one is open at a time.
         * @param {Object} $container - Container holding dropdown elements
         */
        function Dropdowns($container) {
            var dropdowns = this;
            dropdowns.$container = $container;
            dropdowns.$active = undefined;

            dropdowns.$dropdownsElements = $(".js-dropdown-toggle", this.$container);

            dropdowns.Toggle = function Toggle($trigger) {
                if (dropdowns.$active === $trigger) {
                    dropdowns.$active = undefined;
                    $trigger.deactivate();
                } else if (dropdowns.$active) {
                    dropdowns.$active.deactivate(function () {
                        $trigger.activate();
                        dropdowns.$active = $trigger;
                    });
                } else {
                    $trigger.activate();
                    dropdowns.$active = $trigger;
                }
            };

            this.dropdownObjects = $.map(dropdowns.$dropdownsElements, function (element) {
                return new Dropdown(element, dropdowns.$container, dropdowns.Toggle);
            });
        }

        /**
         * The Dropdown object represents a single dropdown that can slide down and up
         *
         * @param {object} button - The dropdown's toggle button
         * @param {object} $container - Container of dropdown elements
         * @param {function} toggle - Funtion to call when the dropdown request a toggle
         */
        function Dropdown(button, $container, toggle) {
            var dropdown = this;
            dropdown.$button = $(button);
            dropdown.toggle = toggle;
            dropdown.$dropdown = $(dropdown.$button.data('for'), $container);

            dropdown.$button.on('click', function () {
                dropdown.toggle(dropdown);
            });

            dropdown.deactivate = function (completed) {
                dropdown.$dropdown.slideUp(completed);
                dropdown.$button.removeClass('active');
            };

            dropdown.activate = function () {
                dropdown.$dropdown.slideDown();
                dropdown.$button.addClass('active');
            };
        }

        /**
         * The Pagination object creates pagination dropdown elements,
         * handles pagination GUI item click events, and keeps track of page
         * changes notifying the store locator of which page to load
         *
         * @param {object} $container - Pagination elements container
         * @param {Store_locator} store_locator - The main store locator
         */
        function Pagination($container, store_locator) {
            var pagination = this;
            this.store_locator = store_locator;
            this.pages = 1;
            this.page = 1;

            this.$dropdown = $('.js-pagination-dropdown', $container);
            this.$previous = $('.js-pagination-prev', $container);
            this.$next = $('.js-pagination-next', $container);
            this.$lastpage = $('.js-pagination-last', $container);

            this.$next.on('click', function () {
                if (pagination.page < pagination.pages) {
                    pagination.updatePagination(pagination.page + 1);
                }
            });

            this.$previous.on('click', function () {
                if (pagination.page > 1) {
                    pagination.updatePagination(pagination.page - 1);
                }
            });

            this.$dropdown.on('change', function () {
                pagination.updatePagination(parseInt(pagination.$dropdown.val()));
            });

            // Create the pagination dropdown elements
            this.setupPagination = function (count) {
                pagination.pages = Math.ceil(count / store_locator.countPerPage);

                pagination.$lastpage.html(pagination.pages);

                var dropdownOptions = [];
                for (var i = 1; i <= pagination.pages; i++) {
                    var index = i.toString();
                    dropdownOptions.push('<option value="');
                    dropdownOptions.push(index);
                    dropdownOptions.push('">');
                    dropdownOptions.push(index);
                    dropdownOptions.push('</option>')
                }
                pagination.$dropdown.html(dropdownOptions.join(''));
            }

            // Update page information and load the requested page
            this.updatePagination = function (page) {
                pagination.$previous.css('visibility', page === 1 ? 'hidden' : 'visible');
                pagination.$next.css('visibility', page === pagination.pages ? 'hidden' : 'visible');
                pagination.$dropdown.val(page);
                pagination.page = page;
                pagination.store_locator.renderPage(page);
            }
        }

        /**
         * The Filter Manager adds and removes filters, keeps track of active filters
         * and enables the clearing of all filters;
         *
         * @param {Object} $filtersContainer - Container holding the filters
         * @param {Object} $selectedFiltersContainer - Container holding the bar were selected filters are displayed
         */
        function FilterManager($filtersContainer, $selectedFiltersContainer, store_locator) {
            var manager = this;

            manager.$filterTags = $(".js-filter-tag", $filtersContainer);
            manager.$selectedFilterLists = $(".js-filters-list", $selectedFiltersContainer);
            manager.$clearAll = $('.js-clear-all-filters', $selectedFiltersContainer)
            manager.selectedFilters = new Set();

            // Create the filters
            manager.filters = $.map(manager.$filterTags, function (element) {
                return new Filter($(element), manager);
            });

            // Add a filer
            if ( window.location.hash === "#suzy_shier" ) {
                $('#filter__store-0').click();
                $('.store__filters-button--filter').click();
            }
            if ( window.location.hash === "#le_chateau" ) {
                $('#filter__store-1').click();
                $('.store__filters-button--filter').click();
            }
            if ( window.location.hash === "#suzy_shier&le_chateau" || window.location.hash === "#le_chateau&suzy_shier" ) {
                $('#filter__store-0').click();
                $('#filter__store-1').click();
                $('.store__filters-button--filter').click();
            }


            // Add a filer
            manager.attach = function (filter) {
                manager.$selectedFilterLists.append(filter.$element);
                manager.selectedFilters.add(filter);

                // bb add url hash
                if (filter.filterValue === "Suzy Shier") {
                    if (window.location.hash === "") { window.location.hash = 'suzy_shier' }
                    else { window.location.hash = window.location.hash + '&suzy_shier' }
                }
                if (filter.filterValue === "Le Chateau") {
                    if (window.location.hash === "") { window.location.hash = 'le_chateau' }
                    else { window.location.hash = window.location.hash + '&le_chateau' }
                }

                manager.update();
            };

            // Remove a filter
            manager.detach = function (filter) {
                filter.deactive();
                manager.selectedFilters.delete(filter);
                manager.update();

                // bb remove url hash
                if (filter.filterValue === "Suzy Shier") {
                    if (window.location.hash === "#suzy_shier") { history.pushState("", "", window.location.pathname) }
                    else { window.location.hash = "le_chateau" }
                }
                if (filter.filterValue === "Le Chateau") {
                    if (window.location.hash === "#le_chateau") { history.pushState("", "", window.location.pathname) }
                    else { window.location.hash = "suzy_shier" }
                }
            };

            manager.$clearAll.on('click', function (e) {
                e.preventDefault();

                manager.selectedFilters.forEach(function (filter) {
                    filter.deactive();
                });
                manager.selectedFilters.clear();
                manager.update();

                history.pushState("", "", window.location.pathname)
            });

            // Show or hide the filters bar
            manager.update = function () {
                if (manager.selectedFilters.size > 0) {
                    $selectedFiltersContainer.show();
                } else {
                    $selectedFiltersContainer.hide();
                }

                store_locator.loadStores();
            }
        }

        /**
         * A Filter object keeps track of a filter's checkbox and
         * badge that appears in the selected filters bar
         *
         * @param {object} $filter - The filter's input element
         * @param {FilterManager} manager - The Filter manage
         */
        function Filter($filter, manager) {
            var filter = this;
            filter.$input = $filter;
            filter.tagGroup = $filter.data('tag');
            filter.filterValue = $filter.val();
            filter.open_now = filter.tagGroup === "open_now";
            filter.open_till_9 = filter.tagGroup === "open_till_9";
            filter.open_sundays = filter.tagGroup === "open_sundays";

            // Construct the filter's badge with a button to remove the filter
            filter.$element = $(
                '<div class="store__selected-filter">' +
                filter.filterValue +
                '</div>'
            );
            filter.$remove = $('<button class="store__selected-filter-close"></button>');
            filter.$remove.appendTo(filter.$element);

            // Notify the manager of request to add or remove the filer
            filter.$input.on('change', function () {
                if (filter.$input[0].checked) {
                    manager.attach(filter);
                } else {
                    manager.detach(filter);
                }
            });
            filter.$remove.on('click', function () {
                manager.detach(filter);
            });

            // When removing the filter ensure to uncheck the input
            filter.deactive = function () {
                filter.$input.prop('checked', false);
                filter.$element.detach();
            };

            // Modify filter settings based on the state of this filter
            filter.addSetting = function (settings) {
                if (filter.$input[0].checked) {
                    var tag = filter.tagGroup;
                    if (filter.open_now) {
                        settings["open_now"] = true;
                    } else if (filter.open_till_9 || filter.open_sundays) {
                        var openingDate;

                        // Parse the existing time or create a new one
                        if (settings.open_at) {
                            openingDate = new Date(Date.parse(settings.open_at));
                        } else {
                            openingDate = new Date();
                            openingDate.setHours(12);
                            openingDate.setMinutes(0);
                            openingDate.setSeconds(0);
                        }

                        // Set the time to 8:59 for open till 9pm
                        // or add the number of days to make the date Sunday for open sunday
                        if (filter.open_till_9) {
                            openingDate.setHours(20);
                            openingDate.setMinutes(59);
                            openingDate.setSeconds(0);
                        } else {
                            var daysToAdd = 7 - openingDate.getDay();
                            openingDate.setDate(openingDate.getDate() + daysToAdd);
                        }

                        settings.open_at = openingDate.toUTCString();
                    } else if (tag) {
                        // Check if we need to initialize the array for this tag
                        if (!settings[tag]) {
                            settings[tag] = [];
                        }
                        settings[tag].push(filter.filterValue);
                    }
                }

                return settings;
            }
        }

        Store_locator.prototype.refreshMap = function () {
            var store_locator = this;

            // Trigger the resize event so that google maps will recalculate bounds
            google.maps.event.trigger(window.theme.map, 'resize');
            if (store_locator.storeBounds) {
                window.theme.map.fitBounds(store_locator.storeBounds, store_locator.fitBoundsPadding);
            }
        };

        // Toggle the visibility of the map
        Store_locator.prototype.toggleMap = function () {
            var store_locator = this;

            if (this.$mapToggleButton.hasClass('active')) {
                store_locator.$container.removeClass("map_stowed");
                this.$mapContainer.slideDown(function () {
                    store_locator.refreshMap();
                });
            } else {
                this.$mapContainer.slideUp(function () {
                    store_locator.$container.addClass("map_stowed");
                });
            }
        };

        Store_locator.prototype.getRadius = function () {
            return this.$filterRadius[0];
        };

        // Get a list of selected filters
        Store_locator.prototype.gatherFilters = function () {
            return this.filtersManager.filters.reduce(function (accumulator, currentValue) {
                return currentValue.addSetting(accumulator);
            }, {});
        };

        // Request a geo location from the browser's geolocation feature
        Store_locator.prototype.geolocate = function () {
            var _ = this;
            if (theme_&& theme_.cart_json && theme_.cart_json.attributes && theme_.cart_json.attributes.location) {
                try {
                    var customer_location = JSON.parse(theme_.cart_json.attributes.location);
                    this.geolocateResponse(customer_location);
                } catch (e) {
                }
            } else {

                // Maxmind's API call
                geoip2.city(
                    function (geolocation) {
                        $.post('/cart/update.js', { 'attributes[location]': JSON.stringify(geolocation) },
                            function (cart) {}, 'json')
                            .done(function (cart) {
                                theme_.cart_json = cart;
                                this.geolocateResponse(geolocation);
                            });
                    },
                    function (error) {
                        /*
                            Fixes the Firefox update issue
                            https://blog.mozilla.org/firefox/how-to-block-fingerprinting-with-firefox/
                        */

                        if (error.code == 'HTTP_ERROR') {
                            _.loadStores();
                        }
                        console.log(error);
                    }
                );
            }
        };

        // Set the position based on the browser's geolocation response
        Store_locator.prototype.geolocateResponse = function (position) {
            this.position = {
                latitude: position.location.latitude || null,
                longitude: position.location.longitude || null
            }

            this.loadStores();
        };

        // Set the position based on Google's geocoding response
        Store_locator.prototype.geocodeResponse = function (response) {
            if(response.status !== "OK") {
                this.$resultsCount.text(0);
                this.$resultsCountContainer.show();
                this.pagination.setupPagination(0);
                this.pagination.updatePagination(0);
                return;
            }

            var location = response.results[0].geometry.location;
            this.position = {
                latitude: typeof location.lat === 'function' ? location.lat() : location.lat,
                longitude: typeof location.lng === 'function' ? location.lng() : location.lng
            }

            this.loadStores();
        };

        // Use Google geocoding to convert the user's search
        // query into coordinates
        Store_locator.prototype.geocode = function () {
            var store_locator = this;
            var geocoder = new google.maps.Geocoder();
            var address = store_locator.$addressLookup.val();

            store_locator.$locationNearby.text(address);

            geocoder.geocode({
                address: address,
                region: 'ca'
            }, function(results, status) {
                if (status === 'OK' && results.length > 0) {
                    store_locator.geocodeResponse({ status: 'OK', results: results });
                } else if (status === 'ZERO_RESULTS') {
                    // Retry with 'city' prefix
                    geocoder.geocode({
                        address: 'city ' + address,
                        region: 'ca'
                    }, function(retryResults, retryStatus) {
                        if (retryStatus === 'OK' && retryResults.length > 0) {
                            store_locator.geocodeResponse({ status: 'OK', results: retryResults });
                        } else {
                            store_locator.geocodeResponse({ status: retryStatus, results: [] });
                        }
                    });
                } else {
                    store_locator.geocodeResponse({ status: status, results: [] });
                }
            });
        }

        Store_locator.prototype.filterStores = function (stores) {
            return stores.filter(function (store) {
                return store.support_in_store_pickup;
            });
        }

        // Load a list of stores from the SI endpoint
        Store_locator.prototype.loadStores = function () {
            var store_locator = this;
            var params = {};
            var address = theme_.utils.getURLParams()['address'] || '';
            if (address.length) {
                store_locator.$addressLookup.val(address);
                theme_.utils.clearURLParams();
                store_locator.$addressSubmit.submit();
                store_locator.$geolocateButton.click();
            } else if (store_locator.position) {
                params.location = {};

                params.location.longitude = store_locator.position.longitude;
                params.location.latitude = store_locator.position.latitude;

                var radius = store_locator.getRadius();

                if (radius) {
                    params.location.radius = radius.value;
                    params.location.units = 'km';
                }
            }

            $.extend(params, store_locator.gatherFilters());

            var settings = {
                'async': true,
                'url': '/apps/api/v1/stores?' + $.param(params),
                'method': 'GET',
                'cache': false
            };

            return $.ajax(settings)
                .done(function(response) {
                    if (store_locator.storepicker) {
                        store_locator.stores = store_locator.filterStores(response.stores);
                    } else {
                        store_locator.stores = response.stores;
                    }

                    $(document).trigger('stores_loaded.StoreLocator', [store_locator.stores]);

                    store_locator.$resultsCount.html(store_locator.stores.length);
                    store_locator.$resultsCountContainer.show();
                    store_locator.pagination.setupPagination(store_locator.stores.length);
                    store_locator.pagination.updatePagination(1);
                })
                .fail(function() {
                    // Return no stores on fail
                    $(document).trigger('stores_loaded.StoreLocator', []);
                });
        };

        Store_locator.prototype.getDirectionURL = function(lat1, lng1, lat2, lng2, mode = 'driving') {
            const base = 'https://www.google.com/maps/dir/?api=1';
            const origin = `origin=${lat1},${lng1}`;
            const destination = `destination=${lat2},${lng2}`;
            const travelmode = `travelmode=${mode}`;
            return `${base}&${origin}&${destination}&${travelmode}`;
        }

        Store_locator.prototype.distance = function($lat1, $lon1, $lat2, $lon2) {
           const p1 = new google.maps.LatLng($lat1, $lon1); 
            const p2 = new google.maps.LatLng($lat2, $lon2); 
            const distance = google.maps.geometry.spherical.computeDistanceBetween(p1, p2);
            return (distance / 1000).toFixed(2);
        }
       
        Store_locator.prototype.renderPage = function (page) {
            var store_locator = this;
               var _ = this;

            // Remove all markers and labels
            store_locator.removeMapObjects(store_locator.markers);
            store_locator.removeMapObjects(store_locator.labels);

            if(!store_locator.stores) {
                this.$storeListContainer.empty();
                return;
            }

            store_locator.markers = [];
            store_locator.labels = [];

            var storesObject = [];
            var storeBounds = new google.maps.LatLngBounds();
            var pageindex = (page - 1) * store_locator.countPerPage;

            store_locator.stores.slice(pageindex, pageindex + store_locator.countPerPage).forEach(function (store, index) {
                var _origin = null;
                var _dist = null;

                var _lat1 = store_locator?.position?.latitude;
                var _long1 = store_locator?.position?.longitude;
                var _lat2 = store?.address?.latitude;
                var _long2 = store?.address?.longitude;
                if(_lat1 && _long1){
                     _origin = _.getDirectionURL(_lat1, _long1, _lat2, _long2);
                     _dist = _.distance(_lat1, _long1, _lat2, _long2);
                }


                var storeId = pageindex + index;

                // Add a marker at the store's position on the map
                var marker = new google.maps.Marker({
                    position: { lat: store.address.latitude, lng: store.address.longitude },
                    title: store.address.name.trim(),
                    map: window.theme.map,
                    icon: {
                        url: window.theme.store_view_oval,
                        size: new google.maps.Size(17, 20),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(8, 20)
                    },
                    label: {
                        text: (index + 1).toString(),
                        color: "white",
                        fontSize: "10px",
                        fontWeight: "600",
                        fontFamily: "Roboto"
                    }
                });

                store_locator.markers.push(marker);

                // Add a label for the store's name on the map
                var label = new MapLabel({
                    align: "left",
                    position: new google.maps.LatLng({ lat: store.address.latitude, lng: store.address.longitude }),
                    map: window.theme.map,
                    text: store.address.name.trim(),
                    fontColor: "black",
                    fontSize: "10px",
                    fontFamily: "Roboto",
                    strokeWeight: 0
                });

                var current_hours = '';

                if (!store.temporarily_closed) {
                    current_hours = store_locator.processHours(store.open_hours);
                } else {
                    current_hours = window.theme.strings.store_locator.temporarily_closed;
                }

                var tile_section_hours = store_locator.hoursContainer(store);
                store_locator.labels.push(label);

                // Add the store coordinates to the bounds
                storeBounds.extend({ lat: store.address.latitude, lng: store.address.longitude });
                storesObject.push('<div class="store__list' + (store.temporarily_closed? ' store__list--temporarily-closed' : '') + '"><div class="store__list-inner">');
                store.checkout_auto_fill = "&locale=" + window.theme_.locale + '&step=contact_information';
                storesObject.push('<div class="store__list-address-cell">');
                storesObject.push('<div class="store__list-address-cell-item">');
                storesObject.push('<h3 class="store__list-title">');
                storesObject.push(store.brand);
                storesObject.push('</h3>');
                storesObject.push('<h3 class="store__list-title store__list-title--name"> ');
                storesObject.push(store.address.name.trim());
                storesObject.push('</h3>');
                storesObject.push('<div class="store__list-address">');
                storesObject.push('<div>');
                storesObject.push(store.address.line1);
                storesObject.push('<br />');
                storesObject.push(store.address.line2);
                storesObject.push('</div>');
                storesObject.push('<div>');
                storesObject.push(store.address.city);
                storesObject.push(', ');
                storesObject.push(store.address.state_code);
                storesObject.push(' ');
                storesObject.push(store.address.zip);
                storesObject.push('</div>');
                storesObject.push('<div class="store__list-phone">');
                if (store.phone) {
                    storesObject.push('<a href="tel:+1');
                    storesObject.push(store.phone.replace(/\D/g, ''));
                    storesObject.push('">');
                    storesObject.push(store.phone);
                    storesObject.push('</a>');
                }
                storesObject.push('</div>');
                storesObject.push('</div>');
                if (store_locator.storepicker) {
                    storesObject.push('<div class="store__list-pick-container">');
                    storesObject = storesObject.concat(store_locator.generatePickButton(storeId));
                    storesObject.push('</div>');
                }
                storesObject.push('</div>');
                storesObject.push('<div class="store__list-address-cell-item _distance">');
                storesObject.push('<span class="store__list-oval" data-index="');
                storesObject.push(index + 1);
                storesObject.push('"><img src="');
                storesObject.push(window.theme.store_view_oval_item);
                storesObject.push('" alt="' + window.theme.strings.store_locator.bubble_alt + " " + (index + 1) + '"/></span>');
                 if (store_locator.storepicker) {
                    storesObject.push('<div class="store__list-pick-container">');
                    storesObject = storesObject.concat(store_locator.generatePickButton(storeId));
                    storesObject.push('</div>');
                }
                if(_dist){
                    storesObject.push('<span class="caption-font">'+ _dist + ' KM</span>');
                }
                storesObject.push('</div>');
                storesObject.push('</div>');

                storesObject.push('<div class="store__list-lower">');
                storesObject.push('<div class="store__list-hours-container">');
                storesObject.push('<div class="store__list-hours-title">');
                storesObject.push(tile_section_hours);
                storesObject.push('</div>');
                storesObject.push('<div class="store__list-hours">');
                storesObject = storesObject.concat(current_hours);
                storesObject.push('</div>');
                storesObject.push('</div>');

                storesObject.push('<div class="store__list-links">');

                storesObject.push('<div class="store__list-directions">');
                if(_origin){ 
                    storesObject.push('<a href="'+ _origin)
                } else {  
                    storesObject.push('<a href="https://www.google.com/maps/dir/?api=1&')
                    storesObject.push($.param({
                        destination: [store.address.line1, store.address.line2, store.address.city, store.address.zip].join(' ')
                    }));
                }
               
                storesObject.push('" target="_blank">');
                storesObject.push(window.theme.strings.store_locator.directions);
                storesObject.push('</a>');
                storesObject.push('</div>');
                storesObject.push('</div>');
                storesObject.push('</div>');

                storesObject.push('</div><div class="store__list-pick-container--mobile">');
                storesObject = storesObject.concat(store_locator.generatePickButton(storeId));
                storesObject.push('</div></div>');
            });

            if (store_locator.stores.length > 0) {
                // Set the map to show the stores
                store_locator.storeBounds = storeBounds;

                if (store_locator.stores.length > 1) {
                    window.theme.map.fitBounds(storeBounds, store_locator.fitBoundsPadding);
                } else {
                    window.theme.map.panTo(storeBounds.getCenter());
                    window.theme.map.setZoom(17);
                }
            }

            // Populate the store list container with the stores
            store_locator.$storeListContainer.html(storesObject.join(''));

            var _titleH =  $('.store__list-hours-title');
            if(_titleH.length){
                _titleH.each(function(){
                    $(this).on('click', function(){
                        $(this).toggleClass('open');
                    });
                });
            }

        }

        /**
         * Converts a list of opening hours to html elements that are grouped by days with the same
         * opening hours
         *
         * @param {object[]} hours - A list of opening and closing hours for each day of the week
         * @returns {object[]} A list of strings representing the constructed DOM elements
         */

        Store_locator.prototype.hoursContainer = function (store) {
            var store_locator = this;
            var _return = '';
            if(store.open) {
                store.open_hours.forEach(function (item) {
                    if(store_locator.getActiveDay(item.day)){
                        _return = store_locator.processAMPM(item.close_time).join('');
                    }

                });

            return  '<span>'+ window.theme_.open[window.theme_.locale] + '<span>'+_return +'</span></span>';

            }
            return window.theme_.close[window.theme_.locale]
        }


        Store_locator.prototype.processHours = function (hours) {
            var store_locator = this;
            var hourGrouping = [];
            var hourOutput = [];
            var hourOutput2 = [];
            var opening_hours;

            // The endpoint from SI starts on Sunday, move that day
            // to the end so that we start on Monday
            if (hours[0].day === 'Sunday') {
                opening_hours = hours.slice(1);
                opening_hours.push(hours[0]);
            } else {
                opening_hours = hours;
            }

            // Iterate through each day of the week
            opening_hours.forEach(function (day, index) {
                if (index === 0) {
                    hourGrouping.push({ start: day });
                    return;
                }

                // Get the previously inserted day
                var lastDay = hourGrouping[hourGrouping.length - 1];

                // If the previous day has the same opening hours, set it ending today,
                // else create a new time range starting today
                if (lastDay.start.open_time === day.open_time && lastDay.start.close_time === day.close_time) {
                    lastDay.end = day;
                } else {
                    hourGrouping.push({ start: day });
                }
            });

            // Construct the DOM elements for the time ranges
            hourGrouping.forEach(function (day) {
                hourOutput.push('<div>');
                hourOutput.push(window.theme_.dayMap[window.theme_.locale][day.start.day]);

                if (day.end) {
                    hourOutput.push(' - ');
                    hourOutput.push(window.theme_.dayMap[window.theme_.locale][day.end.day]);
                }

                hourOutput.push(': ');
                hourOutput = hourOutput.concat(store_locator.processAMPM(day.start.open_time));
                hourOutput.push(' - ');
                hourOutput = hourOutput.concat(store_locator.processAMPM(day.start.close_time));
                hourOutput.push('</div>');
            });

            opening_hours.forEach(function (item) {
                hourOutput2.push('<div ');
                if(store_locator.getActiveDay(item.day)){
hourOutput2.push('class="day-hour-item active"');
                } else {
hourOutput2.push('class="day-hour-item"');
                }
                hourOutput2.push('>');
                hourOutput2.push('<div>');
                hourOutput2.push(window.theme_.dayMap[window.theme_.locale][item.day]);
                hourOutput2.push('</div>');
                hourOutput2.push('<div>');
                hourOutput2 = hourOutput2.concat(store_locator.processAMPM(item.open_time));
                hourOutput2.push(' - ');
                hourOutput2 = hourOutput2.concat(store_locator.processAMPM(item.close_time));
                hourOutput2.push('</div>');
                hourOutput2.push('</div>');

            });


            return hourOutput2;
        }

        /**
         * Convert 24 hour time to DOM elements in am/pm format for
         * english
         *
         * @param {number} time - 24 hour time
         * @returns {string[]} list of constructed DOM strings
         */
        Store_locator.prototype.processAMPM = function (time) {
            var ampmOutput = [];

            if (!time) {
                return;
            }

            var times = time.split(':');

            if(window.theme_.locale === "en") {
                var hour = parseInt(times[0]);

                if (hour > 12) {
                    ampmOutput.push(hour - 12);
                } else if (hour === 0) {
                    ampmOutput.push('12');
                } else {
                    ampmOutput.push(hour);
                }

                if (parseInt(times[1]) >= 0) {
                    ampmOutput.push(':');
                    ampmOutput.push(times[1]);
                }

                ampmOutput.push('<sub>');
                if (hour < 12 || hour === 24) {
                    ampmOutput.push('am');
                } else {
                    ampmOutput.push('pm');
                }
                ampmOutput.push('</sub>');
            } else {
                ampmOutput.push(parseInt(times[0]));
                ampmOutput.push('h');

                if (parseInt(times[1]) >= 0) {
                    ampmOutput.push(times[1]);
                }
            }

            return ampmOutput;
        }
        Store_locator.prototype.getActiveDay = function (day) {

            const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
            const d = new Date();
            return weekday[d.getDay()] == day;
        }

        /**
         * Removes the Map from a list of Google Map objects
         *
         * @param {object} objects - A list of Google Map objects
         */
        Store_locator.prototype.removeMapObjects = function (objects) {
            objects.forEach(function (element) {
                element.setMap(null);
            })
        }

        Store_locator.prototype.generatePickButton = function (store_id) {
            var buttonOutput = [];
            buttonOutput.push('<button class="store__list-pick-button js-pick-store" data-store-id="');
            buttonOutput.push(store_id);
            buttonOutput.push('">');
            buttonOutput.push(window.theme.strings.store_locator.pick_up);
            buttonOutput.push('</button>');

            return buttonOutput;
        }

        return Store_locator;
    };

    window.loadMapLabels = function () {
        var d = "prototype"; function e(a) { this.set("fontFamily", "sans-serif"); this.set("fontSize", 12); this.set("fontColor", "#000000"); this.set("strokeWeight", 4); this.set("strokeColor", "#ffffff"); this.set("align", "center"); this.set("zIndex", 1E3); this.setValues(a) } e.prototype = new google.maps.OverlayView; window.MapLabel = e; e[d].changed = function (a) { switch (a) { case "fontFamily": case "fontSize": case "fontColor": case "strokeWeight": case "strokeColor": case "align": case "text": return h(this); case "maxZoom": case "minZoom": case "position": return this.draw() } };
        function h(a) {
            var b = a.a; if (b) {
                var f = b.style; f.zIndex = a.get("zIndex"); var c = b.getContext("2d"); c.clearRect(0, 0, b.width, b.height); c.strokeStyle = a.get("strokeColor"); c.fillStyle = a.get("fontColor"); c.font = a.get("fontSize") + "px " + a.get("fontFamily"); var b = Number(a.get("strokeWeight")), g = a.get("text"); if (g) {
                    if (b) c.lineWidth = b, c.strokeText(g, b, b); c.fillText(g, b, b); a: { c = c.measureText(g).width + b; switch (a.get("align")) { case "left": a = 0; break a; case "right": a = -c; break a }a = c / -2 } f.marginLeft = a + 11 + "px"; f.marginTop =
                        "-1.4em"
                }
            }
        } e[d].onAdd = function () { var a = this.a = document.createElement("canvas"); a.style.position = "absolute"; var b = a.getContext("2d"); b.lineJoin = "round"; b.textBaseline = "top"; h(this); (b = this.getPanes()) && b.mapPane.appendChild(a) }; e[d].onAdd = e[d].onAdd;
        e[d].draw = function () { var a = this.getProjection(); if (a && this.a) { var b = this.get("position"); if (b) { b = a.fromLatLngToDivPixel(b); a = this.a.style; a.top = b.y + "px"; a.left = b.x + "px"; var b = this.get("minZoom"), f = this.get("maxZoom"); if (b === void 0 && f === void 0) b = ""; else { var c = this.getMap(); c ? (c = c.getZoom(), b = c < b || c > f ? "hidden" : "") : b = "" } a.visibility = b } } }; e[d].draw = e[d].draw; e[d].onRemove = function () { var a = this.a; a && a.parentNode && a.parentNode.removeChild(a) }; e[d].onRemove = e[d].onRemove;
    }

    if (window.store_locator_loader) {
        window.store_locator_loader.done(function () {
            window.loadMapLabels();
            window.store_locator = new Store_locator();
        });
    }
})

/*!
 * Datepicker v1.0.3
 * https://fengyuanchen.github.io/datepicker
 *
 * Copyright 2014-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2018-12-20T12:51:42.329Z
 */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(require("jquery")):"function"==typeof define&&define.amd?define(["jquery"],t):(e=e||self,t(e.jQuery))}(this,function(e){"use strict";function t(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){for(var i=0;i<t.length;i++){var o=t[i];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function o(e,t,o){return t&&i(e.prototype,t),o&&i(e,o),e}function n(e){return A.call(e).slice(8,-1).toLowerCase()}function s(e){return"string"==typeof e}function r(e){return"number"==typeof e&&!P(e)}function a(e){return"undefined"==typeof e}function l(e){return"date"===n(e)&&!P(e.getTime())}function c(e,t){for(var i=arguments.length,o=new Array(i>2?i-2:0),n=2;n<i;n++)o[n-2]=arguments[n];return function(){for(var i=arguments.length,n=new Array(i),s=0;s<i;s++)n[s]=arguments[s];return e.apply(t,o.concat(n))}}function d(e){return'[data-view="'.concat(e,'"]')}function u(e){return e%4===0&&e%100!==0||e%400===0}function p(e,t){return[31,u(e)?29:28,31,30,31,30,31,31,30,31,30,31][t]}function h(e,t,i){return Math.min(i,p(e,t))}function f(t){var i=String(t).toLowerCase(),o=i.match(E);if(!o||0===o.length)throw new Error("Invalid date format.");return t={source:i,parts:o},e.each(o,function(e,i){switch(i){case"dd":case"d":t.hasDay=!0;break;case"mm":case"m":t.hasMonth=!0;break;case"yyyy":case"yy":t.hasYear=!0}}),t}function y(t){var i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],o=e(t),n=o.css("position"),s="absolute"===n,r=i?/auto|scroll|hidden/:/auto|scroll/,a=o.parents().filter(function(t,i){var o=e(i);return(!s||"static"!==o.css("position"))&&r.test(o.css("overflow")+o.css("overflow-y")+o.css("overflow-x"))}).eq(0);return"fixed"!==n&&a.length?a:e(t.ownerDocument||document)}function m(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,i=String(Math.abs(e)),o=i.length,n="";for(e<0&&(n+="-");o<t;)o+=1,n+="0";return n+i}e=e&&e.hasOwnProperty("default")?e.default:e;var v={autoShow:!1,autoHide:!1,autoPick:!1,inline:!1,container:null,trigger:null,language:"",format:"mm/dd/yyyy",date:null,startDate:null,endDate:null,startView:0,weekStart:0,yearFirst:!1,yearSuffix:"",days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],daysShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],daysMin:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"],monthsShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],itemTag:"li",mutedClass:"muted",pickedClass:"picked",disabledClass:"disabled",highlightedClass:"highlighted",template:'<div class="datepicker-container"><div class="datepicker-panel" data-view="years picker"><ul><li data-view="years prev">&lsaquo;</li><li data-view="years current"></li><li data-view="years next">&rsaquo;</li></ul><ul data-view="years"></ul></div><div class="datepicker-panel" data-view="months picker"><ul><li data-view="year prev">&lsaquo;</li><li data-view="year current"></li><li data-view="year next">&rsaquo;</li></ul><ul data-view="months"></ul></div><div class="datepicker-panel" data-view="days picker"><ul><li data-view="month prev">&lsaquo;</li><li data-view="month current"></li><li data-view="month next">&rsaquo;</li></ul><ul data-view="week"></ul><ul data-view="days"></ul></div></div>',offset:10,zIndex:1e3,filter:null,show:null,hide:null,pick:null},g="undefined"!=typeof window?window:{},b="datepicker",w="click.".concat(b),T="focus.".concat(b),k="hide.".concat(b),x="keyup.".concat(b),S="pick.".concat(b),C="resize.".concat(b),_="scroll.".concat(b),O="show.".concat(b),I="".concat(b,"-hide"),j={},$={DAYS:0,MONTHS:1,YEARS:2},A=Object.prototype.toString,P=Number.isNaN||g.isNaN,E=/(y|m|d)+/g,R=/\d+/g,D={show:function(){this.built||this.build(),this.shown||this.trigger(O).isDefaultPrevented()||(this.shown=!0,this.$picker.removeClass(I).on(w,e.proxy(this.click,this)),this.showView(this.options.startView),this.inline||(this.$scrollParent.on(_,e.proxy(this.place,this)),e(window).on(C,this.onResize=c(this.place,this)),e(document).on(w,this.onGlobalClick=c(this.globalClick,this)),e(document).on(x,this.onGlobalKeyup=c(this.globalKeyup,this)),this.place()))},hide:function(){this.shown&&(this.trigger(k).isDefaultPrevented()||(this.shown=!1,this.$picker.addClass(I).off(w,this.click),this.inline||(this.$scrollParent.off(_,this.place),e(window).off(C,this.onResize),e(document).off(w,this.onGlobalClick),e(document).off(x,this.onGlobalKeyup))))},toggle:function(){this.shown?this.hide():this.show()},update:function(){var e=this.getValue();e!==this.oldValue&&(this.setDate(e,!0),this.oldValue=e)},pick:function(e){var t=this.$element,i=this.date;this.trigger(S,{view:e||"",date:i}).isDefaultPrevented()||(i=this.formatDate(this.date),this.setValue(i),this.isInput&&(t.trigger("input"),t.trigger("change")))},reset:function(){this.setDate(this.initialDate,!0),this.setValue(this.initialValue),this.shown&&this.showView(this.options.startView)},getMonthName:function(t,i){var o=this.options,n=o.monthsShort,s=o.months;return e.isNumeric(t)?t=Number(t):a(i)&&(i=t),i===!0&&(s=n),s[r(t)?t:this.date.getMonth()]},getDayName:function(t,i,o){var n=this.options,s=n.days;return e.isNumeric(t)?t=Number(t):(a(o)&&(o=i),a(i)&&(i=t)),o?s=n.daysMin:i&&(s=n.daysShort),s[r(t)?t:this.date.getDay()]},getDate:function(e){var t=this.date;return e?this.formatDate(t):new Date(t)},setDate:function(t,i){var o=this.options.filter;if(l(t)||s(t)){if(t=this.parseDate(t),e.isFunction(o)&&o.call(this.$element,t,"day")===!1)return;this.date=t,this.viewDate=new Date(t),i||this.pick(),this.built&&this.render()}},setStartDate:function(e){l(e)||s(e)?this.startDate=this.parseDate(e):this.startDate=null,this.built&&this.render()},setEndDate:function(e){l(e)||s(e)?this.endDate=this.parseDate(e):this.endDate=null,this.built&&this.render()},parseDate:function(t){var i=this.format,o=[];return l(t)||(s(t)&&(o=t.match(R)||[]),t=t?new Date(t):new Date,l(t)||(t=new Date),o.length===i.parts.length&&e.each(o,function(e,o){var n=parseInt(o,10);switch(i.parts[e]){case"dd":case"d":t.setDate(n);break;case"mm":case"m":t.setMonth(n-1);break;case"yy":t.setFullYear(2e3+n);break;case"yyyy":t.setFullYear(2===o.length?2e3+n:n)}})),new Date(t.getFullYear(),t.getMonth(),t.getDate())},formatDate:function(t){var i=this.format,o="";if(l(t)){var n=t.getFullYear(),s=t.getMonth(),r=t.getDate(),a={d:r,dd:m(r,2),m:s+1,mm:m(s+1,2),yy:String(n).substring(2),yyyy:m(n,4)};o=i.source,e.each(i.parts,function(e,t){o=o.replace(t,a[t])})}return o},destroy:function(){this.unbind(),this.unbuild(),this.$element.removeData(b)}},M={click:function(t){var i=e(t.target),o=this.options,n=this.date,s=this.viewDate,r=this.format;if(t.stopPropagation(),t.preventDefault(),!i.hasClass("disabled")){var a=i.data("view"),l=s.getFullYear(),c=s.getMonth(),d=s.getDate();switch(a){case"years prev":case"years next":l="years prev"===a?l-10:l+10,s.setFullYear(l),s.setDate(h(l,c,d)),this.renderYears();break;case"year prev":case"year next":l="year prev"===a?l-1:l+1,s.setFullYear(l),s.setDate(h(l,c,d)),this.renderMonths();break;case"year current":r.hasYear&&this.showView($.YEARS);break;case"year picked":r.hasMonth?this.showView($.MONTHS):(i.addClass(o.pickedClass).siblings().removeClass(o.pickedClass),this.hideView()),this.pick("year");break;case"year":l=parseInt(i.text(),10),n.setFullYear(l),n.setDate(h(l,c,d)),s.setFullYear(l),s.setDate(h(l,c,d)),r.hasMonth?this.showView($.MONTHS):(i.addClass(o.pickedClass).siblings().removeClass(o.pickedClass),this.renderYears(),this.hideView()),this.pick("year");break;case"month prev":case"month next":c="month prev"===a?c-1:c+1,c<0?(l-=1,c+=12):c>11&&(l+=1,c-=12),s.setFullYear(l),s.setMonth(c),s.setDate(h(l,c,d)),this.renderDays();break;case"month current":r.hasMonth&&this.showView($.MONTHS);break;case"month picked":r.hasDay?this.showView($.DAYS):(i.addClass(o.pickedClass).siblings().removeClass(o.pickedClass),this.hideView()),this.pick("month");break;case"month":c=e.inArray(i.text(),o.monthsShort),n.setMonth(c),n.setDate(h(l,c,d)),s.setMonth(c),s.setDate(h(l,c,d)),r.hasDay?this.showView($.DAYS):(i.addClass(o.pickedClass).siblings().removeClass(o.pickedClass),this.renderMonths(),this.hideView()),this.pick("month");break;case"day prev":case"day next":case"day":"day prev"===a?c-=1:"day next"===a&&(c+=1),d=parseInt(i.text(),10),n.setFullYear(l),n.setMonth(c),n.setDate(d),s.setFullYear(l),s.setMonth(c),s.setDate(d),this.renderDays(),"day"===a&&this.hideView(),this.pick("day");break;case"day picked":this.hideView(),this.pick("day")}}},globalClick:function(e){for(var t=e.target,i=this.element,o=this.$trigger,n=o[0],s=!0;t!==document;){if(t===n||t===i){s=!1;break}t=t.parentNode}s&&this.hide()},keyup:function(){this.update()},globalKeyup:function(e){var t=e.target,i=e.key,o=e.keyCode;this.isInput&&t!==this.element&&this.shown&&("Tab"===i||9===o)&&this.hide()}},q={render:function(){this.renderYears(),this.renderMonths(),this.renderDays()},renderWeek:function(){var t=this,i=[],o=this.options,n=o.weekStart,s=o.daysMin;n=parseInt(n,10)%7,s=s.slice(n).concat(s.slice(0,n)),e.each(s,function(e,o){i.push(t.createItem({text:o}))}),this.$week.html(i.join(""))},renderYears:function(){var e,t=this.options,i=this.startDate,o=this.endDate,n=t.disabledClass,s=t.filter,r=t.yearSuffix,a=this.viewDate.getFullYear(),l=new Date,c=l.getFullYear(),d=this.date.getFullYear(),u=-5,p=6,h=[],f=!1,y=!1;for(e=u;e<=p;e+=1){var m=new Date(a+e,1,1),v=!1;i&&(v=m.getFullYear()<i.getFullYear(),e===u&&(f=v)),!v&&o&&(v=m.getFullYear()>o.getFullYear(),e===p&&(y=v)),!v&&s&&(v=s.call(this.$element,m,"year")===!1);var g=a+e===d,b=g?"year picked":"year";h.push(this.createItem({picked:g,disabled:v,text:a+e,view:v?"year disabled":b,highlighted:m.getFullYear()===c}))}this.$yearsPrev.toggleClass(n,f),this.$yearsNext.toggleClass(n,y),this.$yearsCurrent.toggleClass(n,!0).html("".concat(a+u+r," - ").concat(a+p).concat(r)),this.$years.html(h.join(""))},renderMonths:function(){var t,i=this.options,o=this.startDate,n=this.endDate,s=this.viewDate,r=i.disabledClass||"",a=i.monthsShort,l=e.isFunction(i.filter)&&i.filter,c=s.getFullYear(),d=new Date,u=d.getFullYear(),p=d.getMonth(),h=this.date.getFullYear(),f=this.date.getMonth(),y=[],m=!1,v=!1;for(t=0;t<=11;t+=1){var g=new Date(c,t,1),b=!1;o&&(m=g.getFullYear()===o.getFullYear(),b=m&&g.getMonth()<o.getMonth()),!b&&n&&(v=g.getFullYear()===n.getFullYear(),b=v&&g.getMonth()>n.getMonth()),!b&&l&&(b=l.call(this.$element,g,"month")===!1);var w=c===h&&t===f,T=w?"month picked":"month";y.push(this.createItem({disabled:b,picked:w,highlighted:c===u&&g.getMonth()===p,index:t,text:a[t],view:b?"month disabled":T}))}this.$yearPrev.toggleClass(r,m),this.$yearNext.toggleClass(r,v),this.$yearCurrent.toggleClass(r,m&&v).html(c+i.yearSuffix||""),this.$months.html(y.join(""))},renderDays:function(){var e,t,i,o=this.$element,n=this.options,s=this.startDate,r=this.endDate,a=this.viewDate,l=this.date,c=n.disabledClass,d=n.filter,u=n.months,h=n.weekStart,f=n.yearSuffix,y=a.getFullYear(),m=a.getMonth(),v=new Date,g=v.getFullYear(),b=v.getMonth(),w=v.getDate(),T=l.getFullYear(),k=l.getMonth(),x=l.getDate(),S=[],C=y,_=m,O=!1;0===m?(C-=1,_=11):_-=1,e=p(C,_);var I=new Date(y,m,1);for(i=I.getDay()-parseInt(h,10)%7,i<=0&&(i+=7),s&&(O=I.getTime()<=s.getTime()),t=e-(i-1);t<=e;t+=1){var j=new Date(C,_,t),$=!1;s&&($=j.getTime()<s.getTime()),!$&&d&&($=d.call(o,j,"day")===!1),S.push(this.createItem({disabled:$,highlighted:C===g&&_===b&&j.getDate()===w,muted:!0,picked:C===T&&_===k&&t===x,text:t,view:"day prev"}))}var A=[],P=y,E=m,R=!1;11===m?(P+=1,E=0):E+=1,e=p(y,m),i=42-(S.length+e);var D=new Date(y,m,e);for(r&&(R=D.getTime()>=r.getTime()),t=1;t<=i;t+=1){var M=new Date(P,E,t),q=P===T&&E===k&&t===x,L=!1;r&&(L=M.getTime()>r.getTime()),!L&&d&&(L=d.call(o,M,"day")===!1),A.push(this.createItem({disabled:L,picked:q,highlighted:P===g&&E===b&&M.getDate()===w,muted:!0,text:t,view:"day next"}))}var z=[];for(t=1;t<=e;t+=1){var N=new Date(y,m,t),U=!1;s&&(U=N.getTime()<s.getTime()),!U&&r&&(U=N.getTime()>r.getTime()),!U&&d&&(U=d.call(o,N,"day")===!1);var H=y===T&&m===k&&t===x,F=H?"day picked":"day";z.push(this.createItem({disabled:U,picked:H,highlighted:y===g&&m===b&&N.getDate()===w,text:t,view:U?"day disabled":F}))}this.$monthPrev.toggleClass(c,O),this.$monthNext.toggleClass(c,R),this.$monthCurrent.toggleClass(c,O&&R).html(n.yearFirst?"".concat(y+f," ").concat(u[m]):"".concat(u[m]," ").concat(y).concat(f)),this.$days.html(S.join("")+z.join("")+A.join(""))}},L="".concat(b,"-top-left"),z="".concat(b,"-top-right"),N="".concat(b,"-bottom-left"),U="".concat(b,"-bottom-right"),H=[L,z,N,U].join(" "),F=function(){function i(o){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};t(this,i),this.$element=e(o),this.element=o,this.options=e.extend({},v,j[n.language],e.isPlainObject(n)&&n),this.$scrollParent=y(o,!0),this.built=!1,this.shown=!1,this.isInput=!1,this.inline=!1,this.initialValue="",this.initialDate=null,this.startDate=null,this.endDate=null,this.init()}return o(i,[{key:"init",value:function(){var t=this.$element,i=this.options,o=i.startDate,n=i.endDate,s=i.date;this.$trigger=e(i.trigger),this.isInput=t.is("input")||t.is("textarea"),this.inline=i.inline&&(i.container||!this.isInput),this.format=f(i.format);var r=this.getValue();this.initialValue=r,this.oldValue=r,s=this.parseDate(s||r),o&&(o=this.parseDate(o),s.getTime()<o.getTime()&&(s=new Date(o)),this.startDate=o),n&&(n=this.parseDate(n),o&&n.getTime()<o.getTime()&&(n=new Date(o)),s.getTime()>n.getTime()&&(s=new Date(n)),this.endDate=n),this.date=s,this.viewDate=new Date(s),this.initialDate=new Date(this.date),this.bind(),(i.autoShow||this.inline)&&this.show(),i.autoPick&&this.pick()}},{key:"build",value:function(){if(!this.built){this.built=!0;var t=this.$element,i=this.options,o=e(i.template);this.$picker=o,this.$week=o.find(d("week")),this.$yearsPicker=o.find(d("years picker")),this.$yearsPrev=o.find(d("years prev")),this.$yearsNext=o.find(d("years next")),this.$yearsCurrent=o.find(d("years current")),this.$years=o.find(d("years")),this.$monthsPicker=o.find(d("months picker")),this.$yearPrev=o.find(d("year prev")),this.$yearNext=o.find(d("year next")),this.$yearCurrent=o.find(d("year current")),this.$months=o.find(d("months")),this.$daysPicker=o.find(d("days picker")),this.$monthPrev=o.find(d("month prev")),this.$monthNext=o.find(d("month next")),this.$monthCurrent=o.find(d("month current")),this.$days=o.find(d("days")),this.inline?e(i.container||t).append(o.addClass("".concat(b,"-inline"))):(e(document.body).append(o.addClass("".concat(b,"-dropdown"))),o.addClass(I).css({zIndex:parseInt(i.zIndex,10)})),this.renderWeek()}}},{key:"unbuild",value:function(){this.built&&(this.built=!1,this.$picker.remove())}},{key:"bind",value:function(){var t=this.options,i=this.$element;e.isFunction(t.show)&&i.on(O,t.show),e.isFunction(t.hide)&&i.on(k,t.hide),e.isFunction(t.pick)&&i.on(S,t.pick),this.isInput&&i.on(x,e.proxy(this.keyup,this)),this.inline||(t.trigger?this.$trigger.on(w,e.proxy(this.toggle,this)):this.isInput?i.on(T,e.proxy(this.show,this)):i.on(w,e.proxy(this.show,this)))}},{key:"unbind",value:function(){var t=this.$element,i=this.options;e.isFunction(i.show)&&t.off(O,i.show),e.isFunction(i.hide)&&t.off(k,i.hide),e.isFunction(i.pick)&&t.off(S,i.pick),this.isInput&&t.off(x,this.keyup),this.inline||(i.trigger?this.$trigger.off(w,this.toggle):this.isInput?t.off(T,this.show):t.off(w,this.show))}},{key:"showView",value:function(e){var t=this.$yearsPicker,i=this.$monthsPicker,o=this.$daysPicker,n=this.format;if(n.hasYear||n.hasMonth||n.hasDay)switch(Number(e)){case $.YEARS:i.addClass(I),o.addClass(I),n.hasYear?(this.renderYears(),t.removeClass(I),this.place()):this.showView($.DAYS);break;case $.MONTHS:t.addClass(I),o.addClass(I),n.hasMonth?(this.renderMonths(),i.removeClass(I),this.place()):this.showView($.YEARS);break;default:t.addClass(I),i.addClass(I),n.hasDay?(this.renderDays(),o.removeClass(I),this.place()):this.showView($.MONTHS)}}},{key:"hideView",value:function(){!this.inline&&this.options.autoHide&&this.hide()}},{key:"place",value:function(){if(!this.inline){var t=this.$element,i=this.options,o=this.$picker,n=e(document).outerWidth(),s=e(document).outerHeight(),r=t.outerWidth(),a=t.outerHeight(),l=o.width(),c=o.height(),d=t.offset(),u=d.left,p=d.top,h=parseFloat(i.offset),f=L;P(h)&&(h=10),p>c&&p+a+c>s?(p-=c+h,f=N):p+=a+h,u+l>n&&(u+=r-l,f=f.replace("left","right")),o.removeClass(H).addClass(f).css({top:p,left:u})}}},{key:"trigger",value:function(t,i){var o=e.Event(t,i);return this.$element.trigger(o),o}},{key:"createItem",value:function(t){var i=this.options,o=i.itemTag,n={text:"",view:"",muted:!1,picked:!1,disabled:!1,highlighted:!1},s=[];return e.extend(n,t),n.muted&&s.push(i.mutedClass),n.highlighted&&s.push(i.highlightedClass),n.picked&&s.push(i.pickedClass),n.disabled&&s.push(i.disabledClass),"<".concat(o,' class="').concat(s.join(" "),'" data-view="').concat(n.view,'">').concat(n.text,"</").concat(o,">")}},{key:"getValue",value:function(){var e=this.$element;return this.isInput?e.val():e.text()}},{key:"setValue",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=this.$element;this.isInput?t.val(e):this.inline&&!this.options.container||t.text(e)}}],[{key:"setDefaults",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e.extend(v,j[t.language],e.isPlainObject(t)&&t)}}]),i}();if(e.extend&&e.extend(F.prototype,q,M,D),e.fn){var W=e.fn.datepicker;e.fn.datepicker=function(t){for(var i=arguments.length,o=new Array(i>1?i-1:0),n=1;n<i;n++)o[n-1]=arguments[n];var r;return this.each(function(i,n){var a=e(n),l="destroy"===t,c=a.data(b);if(!c){if(l)return;var d=e.extend({},a.data(),e.isPlainObject(t)&&t);c=new F(n,d),a.data(b,c)}if(s(t)){var u=c[t];e.isFunction(u)&&(r=u.apply(c,o),l&&a.removeData(b))}}),a(r)?this:r},e.fn.datepicker.Constructor=F,e.fn.datepicker.languages=j,e.fn.datepicker.setDefaults=F.setDefaults,e.fn.datepicker.noConflict=function(){return e.fn.datepicker=W,this}}}),function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t(require("jquery")):"function"==typeof define&&define.amd?define(["jquery"],t):t(e.jQuery)}(this,function(e){"use strict";e.fn.datepicker.languages["fr-FR"]={format:"dd-mm-yyyy",days:["Dimanche","Lundi","Mardi","Mercredi","Jeudi","Vendredi","Samedi"],daysShort:["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"],daysMin:["Di","Lu","Ma","Me","Je","Ve","Sa"],weekStart:1,months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Aout","Septembre","Octobre","Novembre","Décembre"],monthsShort:["Jan","Fev","Mar","Avr","Mai","Jun","Jui","Aou","Sep","Oct","Nov","Dec"]}});

